module.exports = __webpack_public_path__ + "static/media/hall-P2.2faac68a.svg";